import React from 'react';
import '../styles/Header.css'
import Button from '@mui/material/Button';


export interface Props {
    casLogo: string;
    signOut: any;
}

export default function Header({casLogo, signOut} : Props) {
    function logOut(){
        localStorage.clear();
        signOut();
    }

    return (
        <div className="HeaderArea">

            <img className="LogoImage"
                 src={casLogo}
                 alt="CASLogo"
                 style={{ height: '4.5vh'}}
            />
            <Button className="Signout_Button" onClick={logOut}>Sign out</Button>
            <p className="Header-Styles">
                CAS AUTOMATED VBA ASSISTANT
            </p>
            <div className="HeaderBottom">
            </div>
        </div>
    );
}